import api from './index.js'

export function getStorageList() {
  return api.get('/api/v1/storage')
}

export function getStorageRequestDetail(storageRequestCode) {
  return api.get(`/api/v1/storage/requests/${storageRequestCode}`)
}

export function updateStorageStatus(storageItemCode, data) {
  return api.patch(`/api/v1/storage/items/${storageItemCode}/status`, data)
}
